// @ts-ignore
export const MODE: string = window.NODE_ENV ?? "";
